import React from 'react'
import FileCounter from './fileCounter'
import ActiveGroup from './activeGroup'
import Sort from './sort'
const style = {
  display: 'flex',
  justifyContent: 'space-between'
}

const Strip = ({ children }) => {
  return (
    <div style={style}>
      <ActiveGroup />
      <div>
        <Sort />
        <FileCounter />
      </div>
      {children}
    </div>
  )
}

export default Strip



// WEBPACK FOOTER //
// ./src/components/Media/Strip/strip.js